import { Layout } from "@/components/Layout";
import { Volunteer } from "@/components/Volunteer";
import { HowToParticipate } from "@/components/HowToParticipate";

export default function PartecipaPage() {
  return (
    <Layout>
      {/* Modulo volontariato direttamente in primo piano */}
      <Volunteer />
      {/* Altri modi per partecipare (segnalazioni + social) */}
      <HowToParticipate />
    </Layout>
  );
}
